import React, { createContext, useContext, useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';

const LoginInfoContext = createContext();

export const useLoginInfo = () => {
  return useContext(LoginInfoContext);
};

export const LoginInfoProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      setCurrentUser(user);
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  return (
    <LoginInfoContext.Provider value={{ currentUser }}>
      {!loading && children}
    </LoginInfoContext.Provider>
  );
};
